import { gql } from 'graphql-tag';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

const getEvaluaciones = gql`
  query Query($idPlantilla: Int) {
    evaluaciones(idPlantilla: $idPlantilla) {
      id
      fechaContable
      idPlantilla
      idInstitucion
    }
  }
`;
const getDetalleEvaluacionCuenta = gql`
  query Query($idEvaluacion: Int) {
    detalleEvaluacionCuentas(idEvaluacion: $idEvaluacion) {
      idCuenta
      idEvaluacion
      valor
    }
  }
`;
const getDetalleEvaluacionVarTemp = gql`
  query Query($idEvaluacion: Int) {
    detalleEvaluacionVarsTemps(idEvaluacion: $idEvaluacion) {
      idEvaluacion
      idVarTemp
      valor
    }
  }
`;
const getDetalleEvaluacionVars = gql `
  query Query($idEvaluacion: Int) {
    detalleEvaluacionVariables(idEvaluacion: $idEvaluacion) {
      idEvaluacion
      idVariable
      valor
    }
  }
`;
const getCuentas = gql`
  query Query($idPlantilla: Int) {
    cuentas(idPlantilla: $idPlantilla) {
      id
      descripcion
      idPlantilla
    }
  }
`;
const getCuenta = gql`
  query Cuenta($cuentaId: String, $idPlantilla: Int, $params: FindOneAccountInput) {
    cuenta(id: $cuentaId, idPlantilla: $idPlantilla, params: $params) {
      id
      descripcion
      tipo
      idPais
      idPlantilla
    }
  }
`;
const getVarsTemp = gql`
  query Query($idPlantilla: Int) {
    varsTemp(idPlantilla: $idPlantilla) {
      id
      idPlantilla
      descripcion
    }
  }
`;
const getVars = gql`
query Query($idPlantilla: Int) {
  variables(idPlantilla: $idPlantilla) {
    descripcion
    id
    idPlantilla
  }
}
`;

export { getCuentas, getCuenta, getEvaluaciones, getDetalleEvaluacionCuenta, getDetalleEvaluacionVarTemp, getVarsTemp, getDetalleEvaluacionVars, getVars }